<template>
    <div class="cluster-content card-content">
        <h2>Clusters Cadastrados</h2>
        <el-table
            v-if="dataCluster.length"
            :data="dataCluster"
            style="width: 100%"
            class="p-table"
            stripe
            border
            size="mini">
            <el-table-column
                prop="nome"
                label="Cluster"
                align="left">
            </el-table-column>
            <el-table-column
                prop="descricao"
                label="Descrição"
                align="left">
            </el-table-column>
        </el-table>
        <div class="no-content" v-if="!dataCluster.length">
            <p>Ainda não existem clusters cadastrados.</p>
            <router-link class="el-button el-button--primary el-button--small is-round" to="/cluster" tag="button">Cadastrar cluster</router-link>
        </div>
    </div>
</template>
 
 <script>
 export default {
    name: 'ClusterCard',
    props: ['dataCluster']
 }
 </script>
 <style lang="scss">
 .cluster-content {
    h2 {
        font-size: 14px;
    }
    .no-content {
        font-size:12px;
        text-align:center;
        min-height:130px;
        line-height: 30px;
    }
 }
 </style>